var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('login-box',{attrs:{"title":"Agent Toolbar Login","loading":_vm.loading,"error":_vm.error},on:{"login":_vm.doLogin}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }